import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { PaymentService } from '../../services/payment.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
/**
 * Side menu Component
 */
let SideMenuComponent = class SideMenuComponent {
    constructor(paymentService, webSettingsService, themeService, sanitizer, googleAnalyticsService) {
        this.paymentService = paymentService;
        this.webSettingsService = webSettingsService;
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.googleAnalyticsService = googleAnalyticsService;
        this.cardsShow = localStorage.getItem('cardsActive');
        this.backColor = '';
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.faqLink = '';
        this.showFaqBoxWithLink = false;
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.textColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        var lang = localStorage.getItem('language');
        this.webSettingsService.getSettings().subscribe((data) => {
            this.faqLink = this.webSettingsService.getCustomValue("SIDE_MENU.FAQ.FAQ_EXTERNAL_LINK.VALUE");
            if (this.faqLink !== undefined) {
                this.faqLink = this.faqLink.trim();
                if (this.faqLink !== '') {
                    this.showFaqBoxWithLink = true;
                }
                else {
                    this.showFaqBoxWithLink = false;
                }
            }
            else {
                this.faqLink = '';
                this.showFaqBoxWithLink = false;
            }
        });
    }
    goToFaq() {
        this.sideMenuClick('FAQ');
        window.open(this.faqLink, '_blank');
    }
    sideMenuClick(category) {
        let array = [];
        array.push({
            'event': 'sideMenuCTAclick',
            button: category
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
};
SideMenuComponent.ctorParameters = () => [
    { type: PaymentService },
    { type: WebClientService },
    { type: WebsiteThemeService },
    { type: DomSanitizer },
    { type: GoogleAnalyticsService }
];
SideMenuComponent = __decorate([
    Component({
        selector: 'ecd-side-menu',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./side-menu.component.html")).default
    })
], SideMenuComponent);
export { SideMenuComponent };
